/** @file Points an attachment at another image; region size and mesh uvs are kept (it stretches). */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';

/** attachment.setImage: a no-op when the attachment already shows that image. */
export const command = defineCommand({
  name: 'attachment.setImage',
  description: 'Point an attachment at another image (name or id); region width/height and mesh uvs stay, so the new image is stretched to them (resize a region with attachment.setTransform).',
  input: z.object({ target: z.string().min(1), image: z.string().min(1) }).strict(),
  apply(draft, input, ctx) {
    const att = draft.attachments[ctx.resolve('attachment', input.target)];
    const image = ctx.resolve('image', input.image);
    if (!att || att.image === image) return;
    att.image = image;
    draft.meta.updatedAt = ctx.now;
  },
});
